export const SET_VISIBILITY = 'SurveyNav/SET_VISIBILITY';
export const SET_SHOW_NEXT_BUTTON = 'SurveyNav/SET_SHOW_NEXT_BUTTON';
export const SET_HIDE_VALIDATION = 'SurveyNav/SET_HIDE_VALIDATION';